export const pxToRem = (px: number) =>
  `calc(${px} / var(--base-font-size, 12) * 1rem)`;
